import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { ENUM__ui_theme } from '@shared/enums/ENUM__ui_theme';
import { useTranslation } from 'react-i18next';
import { CheckboxSettingUser } from '../_base/CheckboxSettingUser';
import { DropdownSettingUserBase } from '../_base/DropdownSettingUserBase';
import { ENUM__settings_user_tab } from '../_base/ENUM__settings_user_tab';
import { S_TAB__user_wrapper } from '../_base/S_TAB__user_wrapper';
import { ButtonShowAllShortcuts } from './button_show_all_shortcuts';

export function TabSettingsUserUI() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  return (
    <S_TAB__user_wrapper type={ENUM__settings_user_tab.UI}>
      <div className="settings-general-utitle-wrapper">
        <span className="settings-general-utitle">{t(i18n_page_settings_user.tabs.ui.categories.general.title)}</span>

        <DropdownSettingUserBase
          setting_key="ui_theme"
          values={Object.values(ENUM__ui_theme)}
          title={`${t(i18n_page_settings_user.tabs.ui.dropdown.ui_theme.label)}:`}
        />
      </div>

      <div className="settings-general-utitle-wrapper">
        <span className="settings-general-utitle">{t(i18n_page_settings_user.tabs.ui.categories.grid.title)}</span>

        <DropdownSettingUserBase
          setting_key="ui_grid2d_cell_size"
          values={Object.values(ENUM__grid2d_cell_size)}
          title={`${t(i18n_page_settings_user.tabs.ui.dropdown.ui_grid2d_cell_size.label)}:`}
        />
      </div>

      <div className="settings-general-utitle-wrapper">
        <span className="settings-general-utitle">{t(i18n_page_settings_user.tabs.ui.categories.shortcuts.title)}</span>

        <ButtonShowAllShortcuts />

        <CheckboxSettingUser settingKey="ui_hints_shortcuts_enabled" i18nKey={i18n_page_settings_user.tabs.ui.categories.shortcuts.checkbox.show_hints} />
      </div>

      <div className="settings-general-utitle-wrapper">
        <span className="settings-general-utitle">{t(i18n_page_settings_user.tabs.ui.categories.performance.title)}</span>
      </div>
    </S_TAB__user_wrapper>
  );
}
